import React from "react";
import "./button.css";
export default function StakeNow() {
  return (
    <button className="inline-flex items-center text-20 sm:text-20 lg:text-18 font-semibold font-inter px-20 md:px-7 py-3 border-2 bg-btnbg border-btnbg hover:bg-transparent rounded-full lg:px-8 lg:py-3 uppercase text-center mt-8 button-hero">
      <span>Stake Now</span>
    </button>
  );
}
